import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { isNew } from 'site-modules/shared/utils/publication-states';
import { Image } from 'site-modules/shared/components/image/image';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';
import { SOURCES } from 'client/utils/image-helpers';
import { VehicleEntities } from 'client/data/models/vehicle-v2';

import './learn-more.scss';

export function LearnMore({ creativeId, photoUrl = '', onRendered = noop, vehicle }) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  if (!vehicle) {
    return null;
  }

  const { make, model, year, pubStates } = vehicle;

  return (
    <div className="learn-more mt-2" data-tracking-parent={creativeId}>
      <h2 className="size-20 fw-bold mb-1">Learn more</h2>
      <Link
        to={getCoreUrl({ makeSlug: make.slug, modelSlug: model.slug, year }, !isNew(pubStates))}
        className="learn-more-link bg-white d-flex align-items-center justify-content-between text-decoration-none ps-0_5 pe-1 py-0_5"
        data-tracking-id="view_review"
        data-tracking-value={`${year} ${make.name} ${model.name} Review`}
      >
        <div className="d-flex align-items-center">
          <div className="learn-more-thumbnail me-0_75">
            <Image
              className="rounded-circle"
              errorImage={getNoVehicleImageToDisplay()}
              alt=""
              imageId={photoUrl}
              source={SOURCES.EDMUNDSCDN}
            />
          </div>
          <div className="size-16">
            <div>Edmunds expert review</div>
            <div className="fw-medium">
              {year} {make.name} {model.name}
            </div>
          </div>
        </div>
        <i className="icon-arrow-right4 size-14 text-cool-gray-40" aria-hidden />
      </Link>
    </div>
  );
}

LearnMore.propTypes = {
  creativeId: PropTypes.string,
  photoUrl: PropTypes.string,
  onRendered: PropTypes.func,
  vehicle: VehicleEntities.Vehicle,
};
